/**
 * Collection Rebuild Service
 * API wrapper for Rekognition collection rebuild operations
 * Uses httpClient for automatic 401 handling and token refresh
 */

import { getTenantConfig } from '../../config/tenantConfig';
import httpClient from './httpClient';

/**
 * Trigger rebuild of Rekognition collection for a dataset
 * @param {string} datasetId - Dataset ID (collection name)
 * @returns {Promise<Object>} Rebuild response
 */
export async function rebuildCollection(datasetId) {
  try {
    const config = getTenantConfig();
    const collectionRebuildApi = config.api.collectionRebuild;

    if (!collectionRebuildApi) {
      console.error('CollectionRebuild API endpoint not configured');
      throw new Error('CollectionRebuild API not configured. Run bin/frontend/configure-api-endpoints.sh');
    }

    console.log(`Triggering collection rebuild for dataset: ${datasetId}`);

    const data = await httpClient.post(`${collectionRebuildApi}/rebuild`, {
      dataset_id: datasetId,
      collection_id: datasetId // Collection ID same as dataset ID
    });

    console.log(`Collection rebuild triggered successfully for ${datasetId}:`, data);
    return data;
  } catch (error) {
    console.error("Error rebuilding collection:", error);
    throw error;
  }
}

/**
 * Get rebuild status (if API supports it)
 * @param {string} datasetId - Dataset ID
 * @returns {Promise<Object>} Rebuild status
 */
export async function getRebuildStatus(datasetId) {
  // TODO: Implement if collectionRebuild Lambda supports status queries
  // For now, rebuild is fire-and-forget async operation
  throw new Error('Rebuild status checking not yet implemented');
}
